// extracted by mini-css-extract-plugin
export default {"residentsHead":"Residents_residentsHead__obVAm","residentsTitle":"Residents_residentsTitle__6yNVe","showMoreWr":"Residents_showMoreWr__XU4+V"};